import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomCheckbox from "src/app/components/CustomCheckbox/CustomCheckbox";
import { getStatisticHeader } from "src/helpers/statistic-list-item";
import { setPublicationSummaryStats } from "src/redux";
import { capitalizeFirstLetter } from "src/utils/methods";

export const ToolbarListPublicationSummaryByProvider = (props) => {
  const { campaignId, provider } = props;

  const {
    reportReducer: { campaigns, publicationSummaryStats },
  } = useSelector((state) => state);

  const { publicationsSummary } = campaigns[campaignId] || {};

  const dispatch = useDispatch();

  const toggleFieldVisibility = (name, checked) => {
    let newValue = publicationSummaryStats[campaignId][provider];

    if (!checked) {
      newValue = [...newValue, name];
    } else {
      newValue = newValue.filter((item) => item !== name);
    }

    dispatch(setPublicationSummaryStats(campaignId, provider, newValue));
  };

  return publicationsSummary[provider]?.summary.map((item) => {
    const checked = publicationSummaryStats[campaignId][provider].includes(
      item.name,
    );

    return (
      <div className="toolbar-list__list-item">
        <CustomCheckbox
          id={`${campaignId}-${provider}-${item.name}-publication`}
          checked={checked}
          onChange={() => toggleFieldVisibility(item.name, checked)}
        />
        {capitalizeFirstLetter(getStatisticHeader(item.name))}
      </div>
    );
  });
};
